import { render } from "./Kontak.vue?vue&type=template&id=477363d7"
import script from "./Kontak.vue?vue&type=script&lang=js"
export * from "./Kontak.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__